import { SuperAdminRelaysPage } from "../../operator/console/super-admin-relays";

export default function ConsoleSuperAdminRelays() {
  return <SuperAdminRelaysPage />;
}
